import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import deleteItem from '../../../../../../actions/deleteItem';
import DeleteItem from './DeleteItem';

const mapStateToProps = ({ estimateBuilder }) => ({
  designId: estimateBuilder.uiState.selectedEstimate,
});

const mapDispatchToProps = dispatch => bindActionCreators({ deleteItem }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DeleteItem);
